interface OverrideSelectProps {
  id: string
  label: string
  value: string
  defaultValue: string
  options: ReadonlyArray<{ value: string; label: string }>
  onChange: (value: string) => void
  onReset: () => void
}

export function OverrideSelect({
  id,
  label,
  value,
  defaultValue,
  options,
  onChange,
  onReset,
}: OverrideSelectProps) {
  const isModified = value !== defaultValue

  return (
    <div>
      <div className="mb-1 flex items-center justify-between">
        <label htmlFor={id} className="text-[13px] text-gray-500">{label}</label>
        {isModified && (
          <button
            type="button"
            onClick={onReset}
            className="rounded-md text-xs text-blue-500 transition-colors motion-reduce:transition-none hover:text-blue-700 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          >
            กลับค่าเริ่มต้น
          </button>
        )}
      </div>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-sm border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-900 transition-colors motion-reduce:transition-none hover:border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  )
}
